import {
    EDIT_USER_RESET,
    EDIT_USER_GENERALES,
    EDIT_USER_ROLES,
    EDIT_USER_PERMISSIONS,
    EDIT_USER_PROJECTS
} from "../redux-const";

const initialState = {
    loading: false,
    tab: 0,
    new: true,
    username: "",
    name: "",
    email: "",
    password: "",
    password2: "",
    active: true,
    permissions: [],
    projects: [],
    roles: [],
    allPermissions: [],
    allRoles: [],
    allProjects: []
}


export const reducer = (state = initialState, action) => {
    const payload = action.payload;
    let selectedRoles = state.selectedRoles
    let selectedPermissions = state.selectedPermissions
    const projects = state.projects

    switch (action.type) {
        case EDIT_USER_GENERALES:
            return {
                ...state,
                ...payload
            }
        case EDIT_USER_RESET:
            return initialState
        case EDIT_USER_ROLES:
            if (selectedRoles.find(r => r.project === payload.project && r.role === payload.role)) {
                selectedRoles = selectedRoles.filter(r => !(r.project === payload.project && r.role === payload.role))
            } else {
                selectedRoles.push({
                    project: payload.project,
                    role: payload.role
                })
            }

            return {
                ...state,
                selectedRoles: [...selectedRoles]
            }
        case EDIT_USER_PERMISSIONS:
            if (selectedPermissions.find(p => p.project === payload.project && p.permission === payload.permission)) {
                selectedPermissions = selectedPermissions.filter(p => !(p.project === payload.project && p.permission === payload.permission))
            } else {
                selectedPermissions.push({
                    project: payload.project,
                    permission: payload.permission
                })
            }

            return {
                ...state,
                selectedPermissions: [...selectedPermissions]
            }
        case EDIT_USER_PROJECTS:
            projects[payload.project].selected = !projects[payload.project].selected === true
            const newState = {
                ...state,
                projects: [...projects]
            }
            console.log("newState", newState.projects[0].selected )
            return newState
        default:
            return state
    }
};

export default reducer;
